<script>
// https://github.com/surmon-china/vue-awesome-swiper
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  components: { swiper, swiperSlide },
  props: {
    currentLanguage: {
      type: String,
      require: true,
      default: "zh-TW"
    },
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    const $self = this;
    return {
      pageCount: 0,
      swiperOption: {
        effect: 'fade',
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        speed: 600,
        on: {
          slideChange () {
            $self.pageCount = ( this.activeIndex % $self.list.length ) || 0
          }
        },
      },
    }
  },
  methods: {
    setSlide(index) {
      this.$refs.memberSwiper.swiper.slideTo((index + 1), 600)
    },
    onNext() {
      if(this.pageCount < this.list.length) {
        this.setSlide(this.pageCount + 1);
      }
    },
    onPrev() {
      if(this.pageCount > 0) {
        this.setSlide(this.pageCount - 1);
      }
    },
    getBackground(item) {
      const { image } = item;
      const imageM = item.image_m ? item.image_m : item.image;

      return this.getWindowWidth() < 992 ? imageM : image;
    },
    getWindowWidth() {
      return document.body.clientWidth;
    },
  },
  mounted() {

    this.setSlide(4)
  }
};
</script>
<template>
  <div>
    <swiper :class="$style.carousel" :options="swiperOption" ref="memberSwiper">
      <!-- slides -->
      <swiper-slide
        v-for="(item, index) in list"
        :key="`${index}carouselSlide`"
        :class="$style.carouselSlide"
      >
        <div :class="$style.carouselInner" :style="{ backgroundImage: `url(${ item.image })` }">
          <div :class="$style.carouselContent"
          >
            <div :class="$style.contentBox">
              <h4 :class="$style.subTitle">{{ currentLanguage !== "zh-TW" && currentLanguage !== "zh-Hant" ? "Listen to what our partners say" : "聽聽我們的夥伴怎麼說" }}</h4>
              <h3 :class="$style.title" v-html="item.content.title"></h3>
              <p :class="$style.content">{{ item.content.content }}</p>
            </div>
            <div :class="$style.metaBox">
              <div :class="$style.meta">
                <span :class="$style.subJobTitle">{{ item.sub_title }}</span> {{ item.title }}
              </div>
              <div :class="$style.name">
                {{ item.content.name }}
              </div>
              <img :alt="$t('global.SIGNATURE')" :class="$style.sign" :src="item.content.sign">
            </div>
          </div>
        </div>
        <div :class="$style.swiperContent">
          <h4 :class="$style.subTitle">{{ currentLanguage !== "zh-TW" && currentLanguage !== "zh-Hant" ? "Listen to what our partners say" : "聽聽我們的夥伴怎麼說" }}</h4>
          <h3 :class="$style.title" v-html="item.content.title"></h3>
          <p :class="$style.content">{{ item.content.content }}</p>
        </div>
      </swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-pagination"  slot="pagination"></div>
    </swiper>

    <div class="row" :class="$style.paginationBox">
      <div class="col"
           :class="[$style.paginationItem, { [$style.hasActive]: (index + 1) === pageCount || (index === 3 && pageCount === 0) }]"
           @click="setSlide(index)"
           v-for="(itemPagination, index) in list"
           :key="index">
        {{ itemPagination.sub_title }}<br>{{ itemPagination.title }}
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
$header-height: 130px;
$pagination-box-height: 110px;
$carousel-bg-height: calc(100vh - #{$header-height} - #{$pagination-box-height});
  .carousel {
    .carouselSlide {
      // height: 840px;
      .carouselInner {
        // height: 40vw;
        height: $carousel-bg-height;
        background-size: cover;
        position: relative;
        background-position: top center ;
        z-index: 1;
        max-height: 75vh;
        min-height: 550px;
        @include touch {
          background-position: top ;
          // background-position-x: -140px;
          height: 50vw;
          max-height: unset;
          min-height: unset;
        }
        &:before {
          content: "";
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          position: absolute;
          background-image: linear-gradient(91deg, #000000 2%, rgba(0, 0, 0, 0.85) 13%, rgba(0, 0, 0, 0) 68%);
        }
        .carouselContent {
          position: absolute;
          z-index: 1;
          color: #fff;
          top: 50%;
          left: 10%;
          transform: translateY(-50%);
          padding-top: 5rem;
          @include touch {
            position: relative;
            padding: 3rem 1.5rem;
            transform: unset;
            z-index: 1;
            top: 0;
            left: 0;
            width: 230px;
            height: 100%;
          }
          .contentBox {
            min-height: 400px;
            @include touch {
              display: none;
            }
            @media screen and (min-height: 1000px){
              height: 400px;
            }
          }
          .metaBox {
            @include touch {
              position: absolute;
              bottom: 20px;
            }
          }
          // 聽聽我們的夥伴怎麼說
          .subTitle {
            @include font(23px, 2.24, 4px, 500);
            font-family: 'Noto Serif TC', serif;
            margin-bottom: 1.5rem;
            @include until-widescreen {
              @include font(20px, 2.24, 4px, 500);
            }
            @include touch {
              @include font(14px, null, null, null);
              margin-bottom: 2rem;
            }
            @media screen and (min-height: 1000px){
              @include font(25px, 2.24, 3.75px, 500);
              margin-bottom: 50px;
            }
          }
          .title {
            @include font(30px, 1.5, 5.4px, 500);
            font-family: 'Noto Serif TC', serif;
            margin-bottom: 2rem;
            @include until-widescreen {
              @include font(26px, 1.5, 5.4px, 500);
            }
            @include touch {
              @include font(16px, null, 3px, null);
              margin-bottom: 1.5rem;
            }
            @media screen and (min-height: 1000px){
              @include font(36px, 1.56, 5.4px, 500);
              margin-bottom: 50px;
            }
          }
          .content {
            @include font(15px, 1.83, 4px, 300);
            width: 45%;
            @include until-widescreen {
              @include font(14px, 26px, null, null);
            }
            @include touch {
              @include font(14px, 26px, null, null);
              width: 100%;
            }
            @media screen and (min-height: 1000px){
              @include font(18px, 1.83, 3.6px, 300);
            }
          }
          .meta {
            @include font(13px, 2.86, 2px, 500);
            font-family: 'Noto Serif TC', serif;
            white-space: nowrap;
            @include touch {
              @include font(12px, 30px, 2.4px, null);
              margin-bottom: 0;
            }
            @media screen and (min-height: 1000px){
              @include font(14px, 2.86, 2px, 500);
            }
          }
          .subJobTitle{
            display: inline;
            @include touch {
              display: block;
            }
          }
          .name {
            @include font(20px, 40px, 4.8px, 500);
            font-family: 'Noto Serif TC', serif;
            @include touch {
              @include font(18px, 30px, 3.6px, null);
              margin-bottom: 1rem;
            }
            @media screen and (min-height: 1000px){
              @include font(24px, 40px, 4.8px, 500);
            }
          }
          .sign {
            max-width: 260px;
            position: relative;
            // top: 0.5rem;
            right: -5.5rem;
            @include until-widescreen {
              width: 145px;
            }
            @include touch {
              left: 0;
              top: 0;
              width: 140px;
            }
          }
        }
      }
      .swiperContent {
        display: none;
        @include touch {
          display: block;
          height: 400px;
          background-color: #f5b18d;
          position: relative;
          z-index: 0;
          padding: 30px 20px;
        }
        .subTitle {
          @include font(14px, 20px, 2.1px, 500);
          font-family: 'Noto Serif TC', serif;
          margin-bottom: 20px;
        }
        .title {
          @include font(16px, 24px, 2.4px, 500);
          font-family: 'Noto Serif TC', serif;
          margin-bottom: 12px;
        }
        .content {
          @include font(12px, 20px, 2.88px, 300);
        }
      }
    }
  }

  .paginationBox {
    @include touch {
      justify-content: center;
      position: absolute;
      // bottom: 1rem;
      bottom: 6rem;
      z-index: 1;
      left: 50%;
      transform: translateX(-30%);
    }
    .paginationItem {
      @include font(20px, 1.5, 5.2px, 500);
      font-family: 'Noto Serif TC', serif;
      color: #2b251b;
      height: 110px;
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
      background: rgba(#e85400, 50%);
      box-shadow: -140px 0 100px -100px rgba(0,0,0,0.1) inset;
      cursor: pointer;
      @include touch {
        font-size: 0;
        width: 12px;
        height: 12px;
        flex-grow: unset;
        flex-basis: unset;
        padding: 0;
        margin: 0 0.5rem;
        border-radius: 100%;
        background: #fff;
      }
      &:hover {
        background: mix(#fff, rgba(#e85400, 50%), 5%);
        @include touch {
          background: #e85400;
        }
      }
      &.hasActive {
        background: #fff;
        box-shadow: unset;
        color: #e85400;
        @include touch {
          background: #e85400;
        }
      }
    }
  }
</style>
